
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/park-tickets",
      function () {
        return require("private-next-pages/park-tickets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/park-tickets"])
      });
    }
  